angular.module('DoohApps').config(['$httpProvider', '$animateProvider', '$uibModalProvider', '$ocLazyLoadProvider', '$compileProvider', '$locationProvider', 'DoohConfigProvider',
    function ($httpProvider, $animateProvider, $uibModalProvider, $ocLazyLoadProvider, $compileProvider, $locationProvider, DoohConfigProvider) {

        var DoohConfig = DoohConfigProvider.$get();
        $compileProvider.debugInfoEnabled(DoohConfig.isDebugMode);
        $compileProvider.commentDirectivesEnabled(false);
        $compileProvider.cssClassDirectivesEnabled(false);
        $locationProvider.hashPrefix('');

        delete $httpProvider.defaults.headers.common['X-Requested-With'];
        $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

        $httpProvider.defaults.transformRequest = function (data) {
            if (data === undefined || data instanceof FormData) {
                return data;
            } else if (data.indexOf != null) {
                if (data.indexOf('<?xml version') > -1)
                    return data;
            }
            return $.param(data);
        };


 }]);